import { RouteConfig } from 'vue-router';
import { NotFound } from '@/components';

const AuthPage = () =>
  import(/* webpackChunkName: "public-routes" */ '@/components/Users/AuthPage.vue');
const LoginForm = () =>
  import(/* webpackChunkName: "public-routes" */ '@/components/Users/LoginForm.vue');
const ForgotForm = () =>
  import(/* webpackChunkName: "public-routes" */ '@/components/Users/ForgotForm.vue');
const JoinForm = () =>
  import(/* webpackChunkName: "public-routes" */ '@/components/Users/JoinForm.vue');
const ResetForm = () =>
  import(/* webpackChunkName: "public-routes" */ '@/components/Users/ResetForm.vue');

const routes: RouteConfig[] = [
  {
    path: '/auth',
    component: AuthPage,
    children: [
      {
        path: 'login',
        name: 'login',
        component: LoginForm,
        meta: {
          public: true
        }
      },
      {
        path: 'forgot',
        name: 'forgot',
        component: ForgotForm,
        meta: {
          public: true
        }
      },
      {
        path: 'join/:token',
        name: 'join',
        component: JoinForm,
        meta: {
          public: true
        },
        props: true
      },
      {
        path: 'reset/:token',
        name: 'reset',
        component: ResetForm,
        meta: {
          public: true
        },
        props: true
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: NotFound,
    meta: {
      pageTitle: '404'
    }
  }
];

export default routes;
